import { Card, CardContent } from '../ui/card';

export const ReportSummaryCards = ({ workerCount, totals, fmt }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    <Card className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm">
      <CardContent className="p-4">
        <p className="text-xs font-medium text-[#5C5C5C] uppercase tracking-wide">Total Workers</p>
        <p className="text-2xl font-bold text-[#1C1C1E] mt-1" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {workerCount}
        </p>
      </CardContent>
    </Card>
    <Card className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm">
      <CardContent className="p-4">
        <p className="text-xs font-medium text-[#5C5C5C] uppercase tracking-wide">Working Days</p>
        <p className="text-2xl font-bold text-[#2E4632] mt-1" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {totals.full_days + totals.half_days}
        </p>
      </CardContent>
    </Card>
    <Card className="bg-[#2E4632] text-white rounded-lg shadow-sm">
      <CardContent className="p-4">
        <p className="text-xs font-medium text-white/80 uppercase tracking-wide">Gross Wage</p>
        <p className="text-2xl font-bold mt-1" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {fmt(totals.gross_wage)}
        </p>
      </CardContent>
    </Card>
    <Card className="bg-[#D97706] text-white rounded-lg shadow-sm">
      <CardContent className="p-4">
        <p className="text-xs font-medium text-white/80 uppercase tracking-wide">Net Payable (Period)</p>
        <p className="text-2xl font-bold mt-1" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {fmt(totals.net_wage)}
        </p>
      </CardContent>
    </Card>
  </div>
);
